<template>
  <div :class="{ 'has-logo': showLogo }">
    <Logo :collapse="isCollapse" v-show="showLogo"></Logo>
    <el-scrollbar wrap-class="scrollbar-wrapper">
      <el-menu
        :collapse="isCollapse"
        :default-active="$route.path"
        text-color="#FFFFFF"
        active-text-color="#0000FF"
        :collapse-transition="false"
        menu-trigger="click"
        unique-opened
        mode="vertical"
        :router="true"
      >
        <SidebarItem
          :collapse="isCollapse"
          v-for="item in this.menuList"
          :item="item"
          :key="item.path.toString()"
          :base-path="item.path"
          v-show="item.type == 0 && !item.hidden"
        />
      </el-menu>
    </el-scrollbar>
  </div>
</template>

<script>
import data from "@/file/menu.json";
import SidebarItem from "./SidebarItem";
import Logo from "./Logo.vue";
import { mapGetters } from "vuex";
import variables from "@/assets/styles/variables.scss";

export default {
  mounted() {
    // bus.$on("sendleft", (data) => {
    //   this.isCollapse = data;
    // });
    this.IsPC();
    var that = this;
    window.onresize = () => {
      return (() => {
        window.fullHeight = document.documentElement.clientHeight;
        window.fullWidth = document.documentElement.clientWidth;
        that.windowHeight = window.fullHeight; // 高
        that.windowWidth = window.fullWidth; // 宽
      })();
    };
    let params = this.$store.state.permission.sidebarRouters;
    params.forEach((item) => {
      if (item.meta != undefined) {
        this.menuList.push(item);
      }
    });
    // console.log("$route.path", this.menuList);
  },
  computed: {
    ...mapGetters(["sidebarRouters", "sidebar"]),
    isCollapse: {
      get() {
        return !this.sidebar.opened;
      },
      set() {},
    },
    showLogo() {
      // console.log('this.$store.state.settings.sidebarLogo',this.$store.state.settings.sidebarLogo);
      return this.$store.state.settings.sidebarLogo;
    },
    variables() {
      return variables;
    },
  },
  data() {
    return {
      // isCollapse: false,
      data,
      path: null,
      windowWidth: document.documentElement.clientWidth, //实时屏幕宽度
      windowHeight: document.documentElement.clientHeight, //实时屏幕高度
      menuList: [],
      language: "",
      show: false,
      mobile: "",
    };
  },
  methods: {
    sidebarList() {
      let params = sidebarRouters;
      params.forEach((item, index) => {
        if (item.meta == undefined) {
          params.splice(index, 1);
        }
      });
      this.menuList = params;
      // console.log("this.menuList", this.menuList);
    },
    IsPC() {
      let userAgent = navigator.userAgent.toLowerCase();
      // 用 test 匹配浏览器信息
      if (
        /ipad|iphone|midp|rv:1.2.3.4|ucweb|android|windows ce|windows mobile/.test(
          userAgent
        )
      ) {
        this.mobile = false;
        console.log("前端是移动端");
      } else {
        this.mobile = true;
        // console.log("前端是pc端");
      }
    },
  },
  watch: {
    windowWidth(val) {
      let that = this;
      if (val < 768) {
        that.dialogWidth = "100%";
      } else {
        that.dialogWidth = "75%";
      }
      if (993 < val < 994) {
        this.isCollapse = true;
      }
    },
    // sidebarRouters: {
    //   handler(newvalue, oldvalue) {
    //     console.log("新", newvalue, "旧", oldvalue);
    //   },
    //   deep: true,
    // },
  },
  components: {
    SidebarItem,
    Logo,
  },
};
</script>

<style scoped>
/* .el-submenu .el-menu-item {
  min-width: 200px;
  background-color: red;
}
.el-aside {
  height: calc(100%-5px);
}
.el-aside::-webkit-scrollbar {
 overflow-x: hidden;
} */
/deep/ .el-icon-arrow-right:before {
  content: "";
}
.el-scrollbar {
  /* overflow: hidden;
  display: flex; */
  bottom: 0;
}
.el-menu {
  border: none !important;
  background-color: transparent !important;
}
.has-logo .el-scrollbar {
  height: calc(100% - 40px);
  width: 100%;
  box-sizing: border-box;
  overflow: hidden;
  z-index: 10000;
}
/deep/.el-menu .el-menu--inline {
  background-color: rgb(4, 61, 2, 0.2);
  /* margin-left: 20px; */
}

/deep/.el-menu .el-menu--inline .el-menu-item .is-active {
  background-color: transparent !important;
  padding-left: 15px !important;
}
/deep/.el-menu .el-menu--inline .el-menu-item {
  background-color: transparent !important;
  padding-left: 15px !important;
}
/* /deep/.el-submenu {
  padding-left: 20px;
} */
</style>
